// extracted by mini-css-extract-plugin
export default {"cart-items":"Cart_cart-items__JZQMY","total":"Cart_total__20sdY","actions":"Cart_actions__nCDUu","button--alt":"Cart_button--alt__dLYAk","button":"Cart_button__Odjau"};